module.exports = __webpack_public_path__ + "img/logo_home.76440791.png";